import { LeadListScope, Permission } from '@up2stay/up2promo-api-client';

/**
 * Others-private (“Privat”) is a workspace-role capability (`leads:read_others`).
 * Do not use `usePermissions().can()` here: `GET …/me/permissions` grants platform
 * staff the full catalog even when their only workspace role is Member, and the
 * leads list then rejects `scope=others_private`.
 */
export function canSeeOthersPrivateLeadsScope(options: {
  permissions: readonly Permission[] | undefined;
  permissionsReady: boolean;
  leadsAlwaysShared: boolean;
}): boolean {
  if (!options.permissionsReady || options.leadsAlwaysShared) {
    return false;
  }
  return (options.permissions ?? []).includes(Permission.LEADS_READ_OTHERS);
}

/**
 * New leads default to private, so the Workspace scope is empty for anyone
 * whose leads are not shared. Open on Mine unless the workspace shares every
 * lead anyway (then Workspace is the superset).
 */
export function defaultLeadsListScope(options: {
  leadsAlwaysShared: boolean;
}): LeadListScope {
  return options.leadsAlwaysShared
    ? LeadListScope.WORKSPACE
    : LeadListScope.MINE;
}

/** Whether a lead the viewer just created is guaranteed to appear in `scope`. */
export function leadsScopeShowsNewOwnLead(options: {
  scope: LeadListScope;
  leadsAlwaysShared: boolean;
}): boolean {
  if (options.scope === LeadListScope.MINE) return true;
  return options.scope === LeadListScope.WORKSPACE && options.leadsAlwaysShared;
}
